const endpoints = {
  signOutPath: 'auth/device/logout/{deviceId}',
  pingPath: 'accounts/', // Must be such that returns new token if refreshed
  oidcPath: 'auth/oidc/v2',
  registerPath: 'auth/register',
  salariesPath: 'salaries/',
  accountsPath: 'accounts/',
  notificationsPath: 'notifications/',
  unregisterNotificationsPath: 'notifications/unregister',
  testNotificationsPath: 'notifications/test/',
  minVersionPath: 'version/client/min',
  newRegisterPath: 'auth/register/new',
  salaryDetailsPath: 'user/salarydetails',
  userSettingsPath: 'user/settings',
  sendMailPath: 'mail/hintsilta',
  newAbsencePath: 'absence',
  absencesPath: 'absences',
  sendEditTaxPath: 'tax/card',
  taxCardsPath: 'tax/cards',
  userAppsPath: 'user/apps/{companyId}',
  yearSalariesPath: 'salaries/years/{year}',
  singleSalaryPath: 'salaries/companies/{companyId}/paydays/{payday}/employments/{employmentId}',
  salaryPdfPath: 'salaries/companies/{companyId}/paydays/{payday}/employments/{employmentId}/pdf?language={language}',
  salaryConfigPath: 'salaries/salaryconfig',
  termsOfServiceStatusPath: 'user/termsofservicestatus',
  termsOfServiceAgreementPath: 'user/agreetermsofservice',
  authorizePath: 'api/v1.0/login/authorize',
  logoutPath: 'logout',
  refreshPath: 'auth/refresh'
}

export default endpoints
